import React, { Component } from 'react'
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import { OrderActions } from '../../../actions';
import OrderList from '../../../components/Orders/List';
import Loader from '../../../components/Loader';
import TitleBar from '../../../components/TitleBar';
import SubnavBar from '../../../components/SubnavBar';


export class Track extends Component {
  constructor(props) {
    super(props);

    this.selectRows = this.selectRows.bind(this);

    this.state = {
      rows: null,
    };
  }
  componentWillMount() {
    this.props.dispatch(OrderActions.getDelivered());
  }

  newOrder = () => {
    browserHistory.push('/order');
  }

  gotoCurrent = () => {
    browserHistory.push('/orders');
  }

  selectRows(rows) {
    const { orders } = this.props;

    let vals = [];
    if (rows && rows !== "none") {
      vals = rows.map(item => {
        const a = _.filter(orders.list, (itm) => itm.id === item).pop();
        return a.trackingNumbers[0].trackingNumber; 
      });
      browserHistory.push(`/order/${vals[0]}`);
    }
  }

  render() {
    const { auth, orders } = this.props;
    const profile = auth.auth.getProfile();
    const isAdmin = _.includes(profile.roles, 'admin');
    let content;
    if (!orders || orders.fetching === true || !orders.list) {
      content = (<Loader />);
    } else {
      content = (<OrderList dataProvider={orders.list} onRowSelection={this.selectRows} isAdmin={isAdmin} multiSelectable={false} delivered />)
    }
    const subnavItems = [
      { key: 1, label: 'New', onClick: this.newOrder },
      { key: 2, label: 'Current Orders', onClick: this.gotoCurrent }
    ];
    return (
      <div className="row">
        <div className="col s12">
          <SubnavBar items={subnavItems} />
          <TitleBar title="Orders Delivered" />
          <div className="row">
            <div className="col s12">
              {content}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapPropsToState = (state) => {
  const { auth, orders } = state;

  const delivered = {
    fetching: (orders) ? orders.fetchingDelivered : false,
    list: (orders) ? orders.delivered : null
  };

  return {
    auth,
    orders: delivered
  }
}

export default connect(mapPropsToState)(Track);


// WEBPACK FOOTER //
// ./src/containers/Orders/Delivered/index.js